// extracted by mini-css-extract-plugin
export default {"separator":"PaymentLink_separator__qZQ9i"};